import React, { useRef } from 'react'
import { Link, Text, useTooltip } from '@afterpaytouch/core'
import { Trans } from '../Trans'
import { useConsumerAmount, useCrossBorderTrade, useMerchantAmount } from '../../state'
import styles from './style.module.css'

export const CrossBorderHeader: React.FC = () => {
  const { isCrossBorder, exchangeRate } = useCrossBorderTrade()
  const merchantAmount = useMerchantAmount()
  const consumerAmount = useConsumerAmount()
  const learnMoreRef = useRef(null)
  const { showTooltip } = useTooltip(learnMoreRef, { bubbleSize: { width: 343 }, testNameSpace: 'cross-border-header-tooltip', caretPlacement: 'bottom' })

  if (!isCrossBorder) {
    return null
  }

  const handleLearnMoreClick = (): void => {
    showTooltip(
      <Text size='S'>
        <Trans
          i18nKey='summary:crossBorderTooltip'
          values={{
            consumerSymbol: consumerAmount?.symbol,
            consumerCurrency: consumerAmount?.currency,
            merchantSymbol: merchantAmount?.symbol,
            merchantCurrency: merchantAmount?.currency,
            exchangeRate,
          }}
          components={{
            wrapHandler: <div className={styles.wrapHandler} />,
          }}
        />
      </Text>
    )
  }

  return (
    <div className={styles.crossBorderHeader}>
      <Text size='XS'>
        <Trans
          i18nKey='summary:crossBorderMessage'
          values={{
            consumerCurrency: consumerAmount?.currency,
          }}
          components={{
            learnMoreLink: <Link ref={learnMoreRef} kind='Underline' testNameSpace='cross-border-header-learn-more' onClick={handleLearnMoreClick} />,
          }}
        />
      </Text>
    </div>
  )
}
